// src/components/inputs/ABCDInput.js
import React from "react";

export default function ABCDInput({ options, value, onChange, disabled, multiple = false }) {
  return (
    <>
      <style>
        {`
          .abc-choice {
            display: flex;
            align-items: center;
            justify-content: center;
            min-width: 42px;
            height: 42px;
            border-radius: 9999px;
            border: 2px solid var(--color-border, #f97316);
            background: transparent;
            color: var(--color-text, #ffffff);
            font-weight: 700;
            font-size: 16px;
            transition:
              transform 0.12s ease-out,
              box-shadow 0.12s ease-out,
              border-color 0.12s ease-out,
              background-color 0.12s ease-out,
              color 0.12s ease-out;
            cursor: pointer;
          }

          /* mocny efekt najechania – pomarańczowe tło + lekki lift */
          .abc-choice:hover {
            background: rgba(249, 115, 22, 0.25);
            border-color: #f97316;
            box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.55);
            transform: translateY(-1px);
          }

          /* zaznaczona odpowiedź – stały pomarańczowy stan */
          .abc-choice.selected {
            background: rgba(249, 115, 22, 0.4);
            border-color: #f97316;
            box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.8);
            /* kolor tekstu z var(--color-text), bez wymuszania czarnego */
          }

          .abc-choice.disabled {
            opacity: 0.6;
            cursor: default;
            box-shadow: none;
            transform: none;
          }
        `}
      </style>

      <div
        style={{
          marginTop: 12,
          display: "flex",
          flexDirection: "row",
          gap: 10,
          flexWrap: "wrap",
        }}
      >
        {options.map((opt, idx) => {
          const isSelected = multiple ? (value || []).includes(idx) : value === idx;

          const classes = [
            "abc-choice",
            isSelected ? "selected" : "",
            disabled ? "disabled" : "",
          ]
            .filter(Boolean)
            .join(" ");

          return (
            <button
              key={idx}
              type="button"
              className={classes}
              onClick={() => !disabled && onChange(idx)}
              disabled={disabled}
              aria-pressed={isSelected}
            >
              {opt.textNode ?? opt.label}
            </button>
          );
        })}
      </div>
    </>
  );
}
